import React, { Component } from 'react'
import { changePage, getUpSellItem } from '../../action/hcommerce'
import { popupOpenClose, setConformPage } from '../../action/action'
import { connect } from 'react-redux'
import propTypes from 'prop-types';
import img4 from '../../images/room-svc/sub_meals/sub_meal04.png'
import { CMSPath } from '../../config/constant'
import defaultImage from '../../images/cover_breakfast.png'
import { setAddOnItems } from '../../JS/setColors'
import { hCommButtonColor } from '../../JS/setColors'

class FoodInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addOn: [],
            quantity: 1,
            upsell: [],
            showAddOns: false,
            showUpSell: false
        }
    }

    componentDidMount() {
        this.props.getUpSellItem(this.props.guestDetail, this.props.SelectedFood.id);
        hCommButtonColor(this.props.menuColor);
    }

    goBack = (buttonName) => {
        if (buttonName === "cancel") {
            this.props.setConformPage(true, "Are you sure, You want to cancel.", "FoodInfo");
        } else {
            this.props.changePage("ItemPage");
        }
    }

    calculateTotalPrice = (item) => {
        let totalPrice;
        totalPrice = item.itemPrice * this.state.quantity;
        this.state.addOn.map((iterator) => {
            totalPrice = totalPrice + iterator.price;
        })
        // this.state.upsell.map((iterator) => {
        //     totalPrice = totalPrice + iterator.itemPrice;
        // })
        console.log("totalPrice", totalPrice);
        return totalPrice;
    }

    orderNow = () => {
        let totalPrice = 0;
        let savedOrders = localStorage.getItem("savedOrders");
        console.log("savedOrders", savedOrders)
        if (savedOrders && savedOrders !== "null") {
            savedOrders = JSON.parse(savedOrders);
        } else {
            savedOrders = []
        }
        totalPrice = this.calculateTotalPrice(this.props.SelectedFood);
        let order;
        order = {
            item: this.props.SelectedFood,
            quantity: this.state.quantity,
            totalPrice: totalPrice,
            addOns: this.state.addOn
        }
        savedOrders.push(order);
        this.state.upsell.map((iterator) => {
            totalPrice = this.calculateTotalPrice(iterator);
            order = {
                item: iterator,
                quantity: 1,
                totalPrice: iterator.itemPrice,
                addOns: []
            }
            savedOrders.push(order);
        });
        savedOrders = JSON.stringify(savedOrders);
        localStorage.setItem("savedOrders", savedOrders);
        //this.props.popupOpenClose(true, "saved to cart.");
        this.props.changePage("myOrder");
    }

    quantityIncress = () => {
        this.setState({ quantity: this.state.quantity + 1 });
    }

    quantityDecrease = () => {
        if (this.state.quantity > 1) {
            this.setState({ quantity: this.state.quantity - 1 });
        } else {
            this.props.popupOpenClose(true, "Can't decrease quantity more than 1.");
        }
    }

    addOnCheckBoxCLick = (event, addOnItem) => {
        let addOnCopy = [...this.state.addOn]
        //console.log("event", event.target.value, addOnItem, event.target.checked);
        if (event.target.checked) {
            addOnCopy.push(addOnItem);
        } else {
            addOnCopy.map((iterator, index) => {
                if (`${iterator.id}` === event.target.value) {
                    addOnCopy.splice(index, 1);
                }
            })
        }
        this.setState({ addOn: addOnCopy });
    }

    upSellClick = (event, upSellItem) => {
        let upsellCopy = [...this.state.upsell];
        console.log("event", event.target.value, upSellItem.id, event.target.checked);
        if (event.target.checked) {
            upsellCopy.push(upSellItem);
        } else {
            upsellCopy.map((iterator, index) => {
                if (`${iterator.id}` === event.target.value) {
                    upsellCopy.splice(index, 1);
                }
            })
        }
        this.setState({ upsell: upsellCopy });
    }

    showAddOnItems = () => {
        console.log("called")
        let element = document.getElementById("rsAddOnItem");
        if (this.state.showAddOns) {
            element.classList.remove("open-item");
            this.setState({ showAddOns: !this.state.showAddOns });
        } else {
            element.classList.add("open-item");
            this.setState({ showAddOns: !this.state.showAddOns });
        }
    }

    showUpSellItems = () => {
        console.log("called")
        let element = document.getElementById("rsUpSellItem");
        if (this.state.showUpSell) {
            element.classList.remove("open-item");
            this.setState({ showUpSell: !this.state.showUpSell });
        } else {
            element.classList.add("open-item");
            this.setState({ showUpSell: !this.state.showUpSell });
        }
    }

    render() {
        //console.log("addOn", this.state.upsell);
        let imagePath = null
        if (this.props.SelectedFood.storeItemImages.length === 1) {
            imagePath = `${CMSPath}${this.props.SelectedFood.storeItemImages[0].imagePath}`
        } else {
            this.props.SelectedFood.storeItemImages.map((images) => {
                if (images.imageType === "LARGE") {
                    imagePath = encodeURI(`${CMSPath}${images.imagePath}`)
                }
            })
        }
        if (this.props.SelectedFood.storeItemImages.length === 0) {
            imagePath = defaultImage
        }
        return (
            <div id="rs-item-details" class="movie-widgets" style={{ color: "inherit" }}>
                <div class="search-back" data-target="rs-item-list" onClick={() => { this.goBack("back") }}>
                    <i class="fa fa-chevron-left" style={{ color: "inherit" }}></i> Back</div>
                <div class="rs-item-order" style={{ color: "inherit" }}>
                    <h4>{
                        this.props.SelectedFood ?
                            `${this.props.SelectedFood.itemName} | ${this.props.currencyCode} ${this.props.SelectedFood.itemPrice}`
                            : null}
                    </h4>
                    <div class="qty-container" style={{ color: "inherit" }}>
                        Quantity
                        <input type="tel" name="" value={this.state.quantity} />
                        <a onClick={this.quantityIncress}><i class="fa fa-plus-circle"></i></a>
                        <a onClick={this.quantityDecrease}><i class="fa fa-minus-circle"></i></a>
                    </div>

                    <div class="rs-item-info" style={{ color: "inherit" }}>
                        <div class="rs-item-thumbnail w-25">
                            <img src={imagePath} />
                        </div>
                        <div class="rs-itam-desc" style={{ color: "inherit" }}>
                            <p>{this.props.SelectedFood.itemDescription}</p>
                        </div>
                    </div>
                    <div class="rs-item-info" style={{ color: "inherit" }}>
                        <div id="rsAddOnItem" class="rs-addons w-40"
                            style={this.props.SelectedFood.addOns.length > 0 ?
                                { color: "inherit" } : { color: "inherit", display: "none" }}>
                            <p
                                class="heading"
                                onClick={this.showAddOnItems}
                                style={{ color: "inherit" }}>
                                Requests:</p>
                            {
                                this.props.SelectedFood.addOns.map((iterator) => {
                                    return (
                                        <div class="form-item" style={{ color: "inherit" }}>
                                            <label class="tick-container" style={{ color: "inherit" }}>
                                                <input type="checkbox" name="addons" value={iterator.id}
                                                    onChange={(event) => { this.addOnCheckBoxCLick(event, iterator) }} />
                                                <span class="checkmark"></span>
                                                {iterator.name}
                                            </label>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div id="rsUpSellItem" class="rs-upsell w-60"
                            style={this.props.upsellItem.length > 0 ?
                                { color: "inherit" } : { color: "inherit", display: "none" }}>
                            <p class="heading" onClick={this.showUpSellItems} style={{ color: "inherit" }}>Our recommendations:</p>
                            {
                                this.props.upsellItem.map((iterator) => {
                                    return (
                                        <div class="form-item" style={{ color: "inherit" }}>
                                            <label class="tick-container" style={{ color: "inherit" }}>
                                                <input type="checkbox" name="addons" value={iterator.id}
                                                    onChange={(event) => { this.upSellClick(event, iterator) }} />
                                                <span class="checkmark"></span>
                                                {`${iterator.itemName} ${this.props.currencyCode} ${iterator.itemPrice}`}
                                            </label>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div class="form-controls center">
                        <a class="button w-25" onClick={this.orderNow}>Order now</a>
                        <a class="button secondary w-25" onClick={() => { this.goBack("cancel") }}>Cancel</a>
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        SelectedFood: state.store.Hcommerce.SelectedFood,
        upsellItem: state.store.Hcommerce.upsellItem,
        myOrders: state.store.Hcommerce.myOrders,
        menuColor: state.store.home.MenuColor,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
        state.store.home.clientConfig.currencyDetails.code : ""
    }
}

export default connect(
    mapStateToProps,
    {
        changePage,
        getUpSellItem,
        popupOpenClose,
        setConformPage
    }
)(FoodInfo);